<script>
    import groupBy from 'lodash/groupBy'
    import find from 'lodash/find'
    import keyBy from 'lodash/keyBy'
    import { Link } from 'svelte-routing'
    import Select from 'svelte-select'

    import { Jobs, LocationOptions } from 'src/store/jobs'
    import { ParentDepartmentsMap, DepartmentHeads } from 'src/store/departments'

    const DEFAULT_DEPARTMENT_NAME = '-'
    const departmentHeadsMap = keyBy($DepartmentHeads, 'position')

    let locationFilter = undefined

    const getDepartmentName = reporting_to => {
        if(!reporting_to || !reporting_to.position) return DEFAULT_DEPARTMENT_NAME;
        if(reporting_to.department) return reporting_to.department;

        const parentDepartments = $ParentDepartmentsMap[reporting_to.position.toString()] || []
        const establishedHeadDepartmentId = find(parentDepartments.reverse(), id => departmentHeadsMap[id.toString()])

        return establishedHeadDepartmentId
                ? departmentHeadsMap[establishedHeadDepartmentId.toString()].department
                : DEFAULT_DEPARTMENT_NAME
    }

    $: filteredJobs = $Jobs.filter(job => {
        if(!locationFilter) return true

        return job.locations.map(job => job.id).includes(locationFilter.value)
    })
    $: departments = Object.values(groupBy(filteredJobs, job => getDepartmentName(job.reporting_to)))
    $: hasLoaded = $Jobs.length > 0
</script>

<main>
    <header>
        <h3>Current Job Openings</h3>

        <div class="location-filter">
            <Select items={$LocationOptions} placeholder="Location filter" bind:selectedValue={locationFilter} />
        </div>
    </header>

    {#if hasLoaded}
        <div class="job-list">
            {#each departments as jobs}
                <div class="department-name">{ getDepartmentName(jobs[0].reporting_to) }</div>

                {#each jobs as job}
                    <div class="job">
                        <Link to="job/{job.id}/"><span class="link">{job.title}</span></Link>

                        {#if job.location_name}
                            <div class="location-names">{job.location_name}</div>
                        {/if}
                    </div>
                {/each}
            {/each}
        </div>
    {:else}
        <div>Job list is loading...</div>
    {/if}
</main>

<style>
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .location-filter {
        margin-left: 10px;
        flex: 0 0 150px;
    }

    .job-list {
    }

    .job {
        margin: 10px 0 20px;
    }

    .department-name {
        margin-top: 30px;
        font-weight: bold;
    }

    .location-names {
        color: #757575;

        font-size: 13px;
    }

    .link {
        text-decoration: none;
        font-size: 16px;
        font-weight: bold;
    }
</style>
